import { GridCellProps } from "@progress/kendo-react-grid";
import * as React from "react";
import { useContext } from "react";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { OdcLoadTypeViewModel } from "../../../../ViewModel/OdcLoadTypeViewModel";
import { EditProjectContext } from "../../../EditProjectContext";
import { setInboundOdcLoadType } from "./SetInboundOdcLoadType";
import { SpdrClientViewModel } from "../../../../ViewModel/SpdrClientViewModel";
import { setReturnOdcLoadType } from "./SetReturnOdcLoadType";
import { PdsrClientViewModel } from "../../../../ViewModel/PdsrClientViewModel";

function getOdcLoadType<T extends SpdrClientViewModel | PdsrClientViewModel>(
  dataItem: T,
  editOdc: string
): string {
  const odc = dataItem?.ODCs?.find((f: OdcLoadTypeViewModel) => f.OdcGsdb === editOdc);

  return odc?.LoadType ?? "";
}

type Props = {
  ftlRouteNumber: string | undefined;
  disabled: boolean;
};

export const LoadTypeCell = ({
  dataItem,
  field,
  ftlRouteNumber,
  disabled,
}: Props & GridCellProps) => {
  const editProjectContext = useContext(EditProjectContext);
  const { project, setProject } = editProjectContext;

  const editODC = field || "";
  const odcLoadType = getOdcLoadType(dataItem, editODC);

  const handleChange = (event: DropDownListChangeEvent) => {
    const ftlRoutes = project.FTLRoutes;

    if (!ftlRoutes) {
      return;
    }

    const isSpdr = dataItem.SpdrId !== undefined;
    if (isSpdr) {
      const updatedFtlRoutes = setInboundOdcLoadType(
        ftlRoutes,
        ftlRouteNumber,
        dataItem.SpdrId,
        editODC,
        event.target.value.value
      );
      setProject({ ...project, FTLRoutes: updatedFtlRoutes });
    } else {
      const updatedFtlRoutes = setReturnOdcLoadType(
        ftlRoutes,
        ftlRouteNumber,
        dataItem.PdsrId,
        editODC,
        event.target.value.value
      );
      setProject({ ...project, FTLRoutes: updatedFtlRoutes });
    }
  };

  const localizedData = [
    { text: "Load", value: "Load" },
    { text: "Unload", value: "Unload" },
    { text: "-", value: "-" },
  ];

  return (
    <td>
      {dataItem.inEdit && !disabled ? (
        <DropDownList
          onChange={handleChange}
          value={localizedData.find((c) => c.value === odcLoadType)}
          data={localizedData}
          textField="text"
        />
      ) : (
        localizedData.find((val) => val.value === odcLoadType)?.text
      )}
    </td>
  );
};
